import { createAction, props } from '@ngrx/store';
import { Dataset } from '../models/dataset';

export const loadDatasetsStores = createAction('[DatasetsStore] Load DatasetsStores', props<{ data: Dataset[] }>());

export const setFilter = createAction('[DatasetsStore] Set Filter', props<{ filterValue: string; sampleTypes: number[] }>());
export const setSampleTypesFilter = createAction('[DatasetsStore] Set Sample Type Filter', props<{ sampleTypes: number[] }>());
export const setSampleTypesSort = createAction('[DatasetsStore] Set Sample Type Sort', props<{ filterSortColumn: string; filterSortDirection: 'asc' | 'desc' }>());
